import type { SVGProps } from "react";
import * as React from "react";

const SvgCodepen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 2 .545-.838a1 1 0 0 0-1.09 0zm10 6.5h1a1 1 0 0 0-.455-.838zm0 7 .545.838A1 1 0 0 0 23 15.5zM12 22l-.545.838a1 1 0 0 0 1.09 0zM2 15.5H1a1 1 0 0 0 .455.838zm0-7-.545-.838A1 1 0 0 0 1 8.5zm9.455-5.662 10 6.5 1.09-1.676-10-6.5zM21 8.5v7h2v-7zm.455 6.162-10 6.5 1.09 1.676 10-6.5zm-8.91 6.5-10-6.5-1.09 1.676 10 6.5zM3 15.5v-7H1v7zm-.455-6.162 10-6.5-1.09-1.676-10 6.5zM13 22v-6.5h-2V22zm8.427-14.32-10 7 1.146 1.64 10-7zm-8.853 7-10-7-1.147 1.64 10 7zm-10 1.64 10-7-1.147-1.64-10 7zm8.853-7 10 7 1.146-1.64-10-7zM11 2v6.5h2V2z"
    />
  </svg>
);
export default SvgCodepen;
